(function ($) {
  Drupal.behaviors.skuQuickview = {
    attach: function (context) {
      $('.js-quickview-item', context).on('mouseover', function () {
        $('.product-sku-quickview', this).addClass('active');
        $('.js-quickview-item').removeClass('active');
      }).on('mouseout', function () {
        $('.product-sku-quickview', this).removeClass('active');
      });
    }
  };
})(jQuery);
